import { render } from "./Home.vue?vue&type=template&id=e88f4fbe"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=e88f4fbe&lang=scss"
script.render = render

export default script